export default "__VITE_ASSET__CJyvfcFh__"